import { cva } from '../tokens/variants';

export const labelVariants = cva(
  'inline-flex items-center gap-1 text-[var(--tk-surface-fg)] select-none',
  {
    variants: {
      size: {
        sm: 'text-xs font-medium',
        md: 'text-sm font-medium',
        lg: 'text-base font-medium',
      },
      disabled: {
        true: 'opacity-60 cursor-not-allowed',
        false: '',
      },
    },
    defaultVariants: { size: 'md', disabled: false },
  },
);
